import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../../Config'
import moment from "moment-timezone";
import * as Utils from "../../../inc/Utils";
import Select from 'react-select'
import DatePicker from "react-datepicker";

export default function CampaignTemplateCreate(props) {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false); 
    const navigate = useNavigate();

    let [lang, setLanguage] = React.useState(null);
    let [langId, setLanguageId] = React.useState(null);
    let [typeId, setTypeId] = React.useState(null);
    let [projectType, setProjectType] = React.useState(null);
    let [projectTypeId, setProjectTypeId] = React.useState(null);
    let [project, setProject] = React.useState(null);
    let [projectId, setProjectId] = React.useState(null);
    let [campaignDate, setCampaignDate] = React.useState(null);
    let [campaign, setCampaign] = React.useState(null);
    let [campaignId, setCampaignId] = React.useState(null);

    let [projectPlaceholder, setProjectPlaceholder] = React.useState('...');
    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('...');

    let [disableProject, setDisableProject] = React.useState(true);
    let [disableCampaign, setDisableCampaign] = React.useState(true);
    let [agency, setAgency] = React.useState(null);

    let refUrl = React.useRef();

    React.useEffect(() => {
        setTypeId(props.typeId);

        (async function() {
            try {
                const resAgency = await Utils.getAgency();
                setAgency(resAgency);

                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);

                const resProjectType = await Utils.getProjectType();
                setProjectType(resProjectType);

                setDisableProject(true);
                setDisableCampaign(true);
                if(langId && langId.id && projectTypeId && projectTypeId.id) {
                    setProjectPlaceholder('กำลังโหลด...');
                    const proj = await Utils.getProjectCode(langId.id, projectTypeId.id);
                    if(proj.data) {
                        setProject(proj.data);
                        setProjectPlaceholder('Select...');
                        setDisableProject(false);
                    }
                    else {
                        setProject(null);
                        setProjectPlaceholder('ไม่พบข้อมูล..');
                        setDisableProject(true);
                    }

                    if(projectId && projectId.project_code) {
                        setCampaignPlaceholder('กำลังโหลด...');
                        const camp = await Utils.getCampaign({
                            langId: langId.id,
                            projectType: projectTypeId.id,
                            projectCode: projectId.project_code,
                            campaignDate: campaignDate
                        });
                        let campaignList = [];
                        campaignList.push({
                            campaign_id: '0638A01',
                            campaign_name: 'NonDefine'
                        });
                        if(typeof camp !== 'undefined' && camp.data) {
                            if(camp.data[0].promotions) {
                                for(let rs of camp.data[0].promotions) {
                                    campaignList.push({
                                        campaign_id: rs.campaign_id,
                                        campaign_name: rs.campaign_name
                                    });
                                }
                            }
                        }
                        else {
                            setCampaignId(campaignList[0]);
                        }
                        setCampaign(campaignList);
                        setCampaignPlaceholder('Select...');
                        setDisableCampaign(false);
                    }
                }

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, [langId, projectTypeId, projectId, campaignDate]);

    const onCreate = () => {
        let name = props.name;
        let url = refUrl.current.value;

        let items = [];
        if(roles.permissionId === Utils.SUPER_ADMIN_ID) {
            let checkboxes = document.getElementsByName('agencyIds[]');
            for (let i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked) {
                    items.push({'agencyId': checkboxes[i].value});
                }
            }
        }
        else {
            items.push({'agencyId': roles.agencyId});
        }

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Campaign Template");
        }
        else if(!typeId) {
            toast.error("กรุณาระบุ Type");
        }
        else if(!langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(!projectTypeId) {
            toast.error("กรุณาระบุ Project Type");
        }
        else if(!projectId) {
            toast.error("กรุณาระบุ Project");
        }
        else if(!campaignId) {
            toast.error("กรุณาระบุ Campaign ID");
        }
        else if(!url) {
            toast.error("กรุณาระบุ URL");
            refUrl.current.focus();
        }
        else if(items.length <= 0) {
            toast.error("กรุณาระบุ Agency อย่างน้อย 1 รายการ");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                items: items,
                                name: name,
                                typeId: typeId ? typeId.id : null,
                                lang: langId ? langId.id : null,
                                projectTypeId: projectTypeId ? projectTypeId.id : null,
                                projectId: projectId ? projectId.project_code : null,
                                campaignDate: campaignDate ? new Date(campaignDate) : null,
                                campaignId: campaignId ? campaignId.campaign_id : null,
                                url: url,
                                status: statusChecked[0].checked ? 1:0,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                                fetch(Config.url.API_URL +'/api/campaignTemplate/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/campaignTemplate', {replace: true});
                                    }, 1500);
                                }
                                else {
                                    setLoading(false);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeLanguageId = (obj) => {
        setLanguageId(obj);
        setProjectTypeId(null);
        setProject(null);
        setProjectId(null);
        setCampaign(null);
        setCampaignId(null);
        refUrl.current.value = '';
    };

    const onChangeProjectTypeId = (obj) => {
        setProjectTypeId(obj);
        setProjectPlaceholder('...');
        setProject(null);
        setProjectId(null);
        setCampaign(null);
        setCampaignId(null);
        refUrl.current.value = '';
    };

    const onChangeProjectId = (obj) => {
        setProjectId(obj);
        setCampaignPlaceholder('...');
        setCampaign(null);
        setCampaignId(null);
        refUrl.current.value = obj && obj.project_url? obj.project_url : '';
    };

    const onChangeCampaignDate = (value) => {
        setCampaignDate(value);
        setCampaign(null);
        setCampaignId(null);
    };

    const onChangeCampaignId = (obj) => {
        setCampaignId(obj);
    };

    return (
        <>
            <div className="col-12">
                <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                <Select
                    classNamePrefix="form-select-search"
                    options={lang}
                    onChange={(event) => onChangeLanguageId(event)}
                    value={langId}
                    getOptionValue={(option) => `${option.id}`}
                    getOptionLabel={(option) => `${option.name}`}
                />
            </div>
            <div className="col-12">
                <label htmlFor="projectTypeId" className="form-label">Project Type <span className="text-danger">*</span></label>
                <Select
                    classNamePrefix="form-select-search"
                    options={projectType}
                    onChange={(event) => onChangeProjectTypeId(event)}
                    value={projectTypeId}
                    getOptionValue={(option) => `${option.id}`}
                    getOptionLabel={(option) => `${option.name}`}
                />
            </div>
            <div className={projectTypeId ? 'col-12':'d-none'}>
                <label htmlFor="projectId" className="form-label">Project <span className="text-danger">*</span></label>
                <Select
                    isDisabled={disableProject}
                    classNamePrefix="form-select-search"
                    placeholder={projectPlaceholder}
                    options={project}
                    onChange={(event) => onChangeProjectId(event)}
                    value={projectId}
                    getOptionValue={(option) => `${option.project_code}`}
                    getOptionLabel={(option) => `${option.project_code} : ${option.project_title}`}
                />
            </div>
            <div className={projectTypeId ? 'col-12':'d-none'}>
                <label htmlFor="campaignDate" className="form-label">Campaign Date <span className="text-danger d-none">*</span></label>
                <DatePicker
                    selected={campaignDate}
                    onChange={(date) => onChangeCampaignDate(date)}
                    dateFormat="yyyy-MM-dd"
                    wrapperClassName="w-100"
                    className="form-control w-100" />
            </div>
            <div className={projectTypeId ? 'col-12':'d-none'}>
                <label htmlFor="campaignId" className="form-label">Campaign ID <span className="text-danger">*</span></label>
                <Select
                    isDisabled={disableCampaign}
                    classNamePrefix="form-select-search"
                    placeholder={campaignPlaceholder}
                    options={campaign}
                    onChange={(event) => onChangeCampaignId(event)}
                    value={campaignId}
                    getOptionValue={(option) => `${option.campaign_id}`}
                    getOptionLabel={(option) => `${option.campaign_id} : ${option.campaign_name}`}
                />
            </div>
            <div className="col-12">
                <label htmlFor="url" className="form-label">URL <span className="text-danger">*</span></label>
                <textarea className="form-control" id="url" ref={refUrl} rows={5} disabled={true}></textarea>
            </div>
            <div className={"col-12" + (roles.permissionId === Utils.SUPER_ADMIN_ID ? '':' d-none')}>
                <label htmlFor="agencyx" className="form-label">Agency</label>
                {
                    agency === null || agency.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                        agency.map((row, index) => {
                            let chkId = 'agencyCheck' + row.id;
                            return (
                                <div key={index} className="form-check ms-2">
                                    <input className="form-check-input" name="agencyIds[]" type="checkbox" value={row.id} id={chkId} />
                                    <label className="form-check-label" htmlFor={chkId}>
                                        {row.name} {row.isEncrypt ? <span className="badge bg-secondary small">encrypt</span>:''}
                                    </label>
                                </div>);
                        })
                }
            </div>

            <div className="col-12">
                <label htmlFor="statusx" className="form-label">สถานะ</label>
                <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" defaultChecked={true} />
                    <label className="form-check-label" htmlFor="status"></label>
                </div>
            </div>
            <div className="col-12">
                <button type="button" className="btn btn-primary" onClick={onCreate} disabled={isLoading}><span
                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                <NavLink className="btn btn-sm btn-light ms-2" to='/campaignTemplate'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                <Toaster position="bottom-right" />
            </div>
        </>
    );
} 